<template>
  <router-view :status="status"></router-view>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    status: 0,
  }),
  created () {
    let self = this
    self.getStatus()
    setInterval(function () { self.getStatus() }, 5000 * 1)
  },
  methods: {
    getStatus () {
      this.axios.get('https://6vvdzic3fh.execute-api.ap-northeast-1.amazonaws.com/prod')
      .then((response) => {
        this.status = response.data.status
      })
    },
    postStatus (status) {
      this.axios.post(
        'https://6vvdzic3fh.execute-api.ap-northeast-1.amazonaws.com/prod',
        {
          status: status
        }
      )
    },
  }
};
</script>
